const binding = { modules: {}, dataActions: {} };

    (binding.modules['image-card'] = {
        c: () => require('partner/modules/image-card/image-card.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'image-card',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/image-card'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|image-card|image-card'] = {
                c: () => require('partner/modules/image-card/image-card.view.tsx'),
                cn: '__local__-__local__-image-card'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };